import { urls as LightningUrls } from 'lightning-common/lib/configuration';

import { getHtmlCopy } from '../../i18n';
import { List } from '../common/List';
import { LogoOverDriveWhite } from '../logos';
import { FooterLink } from './FooterLink';
import { FooterPromoColumn, DeviceIconLink } from './FooterPromos';

interface FooterOverDrivePromoColumnProps {
    openInNewWindow?: boolean;
    showKindlePromo?: boolean;
    showWindowsLink?: boolean;
}

export const FooterOverDrivePromoColumn = ({
    openInNewWindow,
    showKindlePromo,
    showWindowsLink,
}: FooterOverDrivePromoColumnProps) => (
    <FooterPromoColumn
        logo={<LogoOverDriveWhite />}
        openInNewWindow={openInNewWindow}
        showKindlePromo={showKindlePromo}
        tagLine={'footer.getTheAppSentence'}
    >
        <List
            className="footer__promo-icon-links"
            heading={getHtmlCopy('overdriveApp')}
        >
            <DeviceIconLink
                gaAction="od_app_click"
                href={LightningUrls.androidODAppUrl}
                iconName="android"
                label={getHtmlCopy('googlePlayStore')}
                openInNewWindow={openInNewWindow}
            />

            <DeviceIconLink
                gaAction="od_app_click"
                href={LightningUrls.iOSODAppUrl}
                iconName="apple"
                label={getHtmlCopy('appleAppStore')}
                openInNewWindow={openInNewWindow}
            />

            {showWindowsLink && (
                <DeviceIconLink
                    gaAction="od_app_click"
                    href={LightningUrls.winODAppUrl}
                    iconName="windows"
                    label={getHtmlCopy('windowsStore')}
                    openInNewWindow={openInNewWindow}
                />
            )}
        </List>
    </FooterPromoColumn>
);

export const FooterOverDriveChinaPromoColumn = ({
    openInNewWindow,
    showKindlePromo,
}: FooterOverDrivePromoColumnProps) => (
    <FooterPromoColumn
        logo={<LogoOverDriveWhite />}
        openInNewWindow={openInNewWindow}
        showKindlePromo={showKindlePromo}
        tagLine={'footer.getTheAppSentence'}
    >
        <List
            className="footer__promo-links"
            heading={getHtmlCopy('overdriveApp')}
        >
            <FooterLink
                href="http://zhushou.360.cn/detail/index/soft_id/3890677?recrefer=SE_D_Libby"
                openInNewWindow={openInNewWindow}
                text="360"
            />

            <FooterLink
                href="http://www.lenovomm.com/app/21633881.html"
                openInNewWindow={openInNewWindow}
                text="Lenovo"
            />

            <FooterLink
                href="https://www.25pp.com/ios/detail_3531872/"
                openInNewWindow={openInNewWindow}
                text="PP"
            />
        </List>
    </FooterPromoColumn>
);
